// observe content change
function observeContentChange(selector, callbackFuncName) {
    // Get the element to observe
    let $element = jQuery(selector);

    // Check if the element exists
    if ($element.length === 0) {
        return;
    }

    // Create a new MutationObserver and pass it a callback function
    let observer = new MutationObserver(function(mutations) {

        // Iterate through the mutations array and check if the content of the element has changed
        mutations.forEach(function(mutation) {
            if (jQuery(mutation.target).is(selector)) {

                // If a callback function name was passed, call the function
                if (typeof callbackFuncName === 'function') {
                    callbackFuncName();
                }
            }
        });
    });

    // Set the observer options and start observing
    let observerConfig = { childList: true, subtree: true };
    observer.observe($element[0], observerConfig);
}
